import React, { useEffect, useState } from "react";
import { Plus, Loader2 } from "lucide-react";
import { fetchProgramas } from "../../lib/programasSoftware";
import { ProgramaCard } from "./ProgramaCard";
import { ProgramaFormModal } from "./ProgramaFormModal";

export const ProgramasSoftware = ({ isAdmin }) => {
  const [programas, setProgramas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const cargar = async () => {
    try {
      const data = await fetchProgramas();
      setProgramas(data);
    } catch {
      setProgramas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargar();
  }, []);

  const abrirNuevo = () => {
    setEditing(null);
    setModalOpen(true);
  };
  const abrirEdicion = (programa) => {
    setEditing(programa);
    setModalOpen(true);
  };

  // El Programa Maestro COREX ya no se lista aquí: su acceso es exclusivo desde el encabezado (Hero).
  // PASO 1 (ajuste): SOLO se ocultan las 2 tarjetas legacy (vivienda-multifamiliar y
  // corex-valorizaciones). Las demás (Carreteras, Hidráulicas, Saneamiento, Estructuras,
  // Instalaciones) vuelven a mostrarse como base reutilizable. Sin tocar datos/seeds/backend.
  const LEGACY_SLUGS = new Set(["vivienda-multifamiliar", "corex-valorizaciones"]);
  const esLegacyOculto = (p) => LEGACY_SLUGS.has((p.slug || "").toLowerCase());
  const especializados = programas.filter((p) => p.type !== "MASTER_PROGRAM" && !esLegacyOculto(p));

  return (
    <section id="programas-software" className="mt-10 scroll-mt-24" data-testid="software-programas">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-2xl font-extrabold tracking-tight text-slate-900">
            Programas Especializados
          </h2>
          <p className="mt-1 max-w-2xl text-sm text-slate-600">
            Soluciones especializadas para cada tipo de proyecto. El acceso a COREX está en el encabezado principal.
          </p>
        </div>
        {isAdmin && (
          <button
            type="button"
            onClick={abrirNuevo}
            data-testid="programa-agregar-btn"
            className="inline-flex items-center gap-2 rounded-xl border border-emerald-600 bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-emerald-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-700"
          >
            <Plus size={16} aria-hidden="true" /> Agregar programa
          </button>
        )}
      </div>

      {loading ? (
        <div className="mt-8 flex items-center justify-center py-10 text-slate-400" data-testid="software-programas-loading">
          <Loader2 className="animate-spin" size={22} />
        </div>
      ) : especializados.length === 0 ? (
        <p className="mt-8 rounded-xl border border-dashed border-slate-200 bg-slate-50 p-6 text-center text-sm text-slate-500" data-testid="software-programas-empty">
          Aún no hay programas especializados registrados.
        </p>
      ) : (
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
          {especializados.map((p) => (
            <ProgramaCard
              key={p.id}
              programa={p}
              isAdmin={isAdmin}
              onEdit={abrirEdicion}
              onMediaSaved={cargar}
            />
          ))}
        </div>
      )}

      {isAdmin && (
        <ProgramaFormModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onSaved={cargar}
          programa={editing}
        />
      )}
    </section>
  );
};
